export function getStartOfDay(date: Date): Date {
    if (date) {
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return new Date(year,month,day,0,0,0,0);
    }
    else {
        return null;
    }
}


export function getEndOfDay(date: Date): Date {
    if (date) {
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return new Date(year,month,day,23,59,59);
    }
    else {
        return null;
    }
}
